// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ppUgTuwpl7o8NTpydjCK{display:flex}.Ai5ym6Pat58S6rJgmGcZ{background-color:var(--background-neutral-secondary);border-radius:100px;width:2px;height:8px;margin-right:3px}.Ai5ym6Pat58S6rJgmGcZ:last-of-type{margin-right:0}.Y8Gg3jkT8AUEebnTSNXZ{background-color:var(--background-brand-default)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ppUgTuwpl7o8NTpydjCK`,
	"wrap__item": `Ai5ym6Pat58S6rJgmGcZ`,
	"wrapItem": `Ai5ym6Pat58S6rJgmGcZ`,
	"wrap__item--active": `Y8Gg3jkT8AUEebnTSNXZ`,
	"wrapItemActive": `Y8Gg3jkT8AUEebnTSNXZ`
};
export default ___CSS_LOADER_EXPORT___;
